/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type ServiceAdminUserCreateMutationVariables = Types.Exact<{
  organizationId: Types.Scalars['ID'];
  input: Types.ServiceAdminUserCreateInput;
}>;


export type ServiceAdminUserCreateMutation = { __typename: 'Mutation', serviceAdminUserCreate: { __typename: 'User', id: string } };


export const ServiceAdminUserCreateDocument = gql`
    mutation ServiceAdminUserCreate($organizationId: ID!, $input: ServiceAdminUserCreateInput!) {
  serviceAdminUserCreate(organizationId: $organizationId, input: $input) {
    id
  }
}
    `;
export type ServiceAdminUserCreateMutationFn = ApolloReactCommon.MutationFunction<ServiceAdminUserCreateMutation, ServiceAdminUserCreateMutationVariables>;

/**
 * __useServiceAdminUserCreateMutation__
 *
 * To run a mutation, you first call `useServiceAdminUserCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useServiceAdminUserCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [serviceAdminUserCreateMutation, { data, loading, error }] = useServiceAdminUserCreateMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useServiceAdminUserCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ServiceAdminUserCreateMutation, ServiceAdminUserCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ServiceAdminUserCreateMutation, ServiceAdminUserCreateMutationVariables>(ServiceAdminUserCreateDocument, options);
      }
export type ServiceAdminUserCreateMutationHookResult = ReturnType<typeof useServiceAdminUserCreateMutation>;
export type ServiceAdminUserCreateMutationResult = ApolloReactCommon.MutationResult<ServiceAdminUserCreateMutation>;
export type ServiceAdminUserCreateMutationOptions = ApolloReactCommon.BaseMutationOptions<ServiceAdminUserCreateMutation, ServiceAdminUserCreateMutationVariables>;